import type { ReactNode } from 'react'

import { useTheme } from '@apps-common/hooks/useTheme'

interface IProps {
  lightComponent: ReactNode
  darkComponent: ReactNode
}

export const ThemeModeComponentSwitcher: React.FC<IProps> = ({ lightComponent, darkComponent }) => {
  const { globalThemeMode } = useTheme()

  return <>{globalThemeMode === 'dark' ? darkComponent : lightComponent}</>
}
